import { useState } from "react";
import BrianyCareLogo from '../../assets/auth/BrainyCare-Logo.jpg';
import { useNavigate } from "react-router-dom";
import ToastMessage from "../../utils/mui/righttoptoast";
import api from "../../api/api";
import { generateRandomToken } from "../../utils/stinggenerator";
import axios from "axios";
import { useLocation } from 'react-router-dom';
const Forgotpassword = () => {
  const [email, setEmail] = useState('');
  const [alertmessage, setAlertMessage] = useState('');
  const [severity, setSeverity] = useState('success');
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false); // Loading state
  const navigate = useNavigate();
    const { search } = useLocation();
  const practiseid = window.getPracticeId();
const query = new URLSearchParams(search);
  const flow = query.get('flow') || 'false'
  const handlealert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async () => {
    if (!email) {
      setAlertMessage('Please enter your email address.');
      setSeverity('error');
      setOpen(true);
      return;
    }
  
    if (!validateEmail(email)) {
      setAlertMessage('Invalid email address. Please enter a valid email.');
      setSeverity('error');
      setOpen(true);
      return;
    }
  
    setLoading(true); // Start loading state
  
    try {
      const token = generateRandomToken(); // Generate the token
      const baseUrl = window.location.origin; // Dynamically gets the domain where the app is running
      const resetLink = `${baseUrl}/reset/${token}`;
      // Send the request to the forgot password API
      const response = await api.post(`/v1/${practiseid}/auth/forgot-password`, {
        "useremail": email,
        "token": token  
      });
  
      // Email message with enhanced HTML UI
      const message = `
        <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; border: 1px solid #ddd; border-radius: 8px; background-color: #f9f9f9;">
          <h2 style="color: #555;">Password Reset Request</h2>
          <p style="font-size: 14px; line-height: 1.6;">Hi there,</p>
          <p style="font-size: 14px; line-height: 1.6;">
            We received a request to reset your password. Click the button below to reset it:
          </p>
          <a href="${resetLink}" 
            style="display: inline-block; padding: 10px 20px; margin: 10px 0; color: #fff; background-color: #007BFF; text-decoration: none; border-radius: 5px;">
            Reset Password
          </a>
          <p style="font-size: 14px; line-height: 1.6;">
            If you did not request this, you can safely ignore this email.
          </p>
          <p style="font-size: 14px; line-height: 1.6; margin-top: 20px;">
            Thanks,<br />
            The Team
          </p>
        </div>
      `;
  if(response.status===200){
const formData = new FormData();
formData.append("subject", "Forgot password email");
formData.append("to", email);
formData.append("message", message);

const resp = await axios.post("/utility/send-email", formData, {
  headers: {
    "Content-Type": "multipart/form-data",
  },
})
      if (resp.status === 200) {
        setAlertMessage('Password reset instructions sent to your email.');
        setSeverity('success');
        setOpen(true);
  
        // Clear the fields and stop loading
        setEmail('');
        setLoading(false);
        setTimeout(() => {
            navigate('/login');
          }, 2000);
      }else{
      setAlertMessage(response.message);
    setSeverity('info');
    setOpen(true);
      }
  }else{
    setAlertMessage(response.message);
    setSeverity('info');
    setOpen(true);
  

  }
      // Send the email with the reset link
     
    } catch (error) {
      setAlertMessage('Something went wrong');
      setSeverity('error');
      setOpen(true);
      console.log(error);
      setLoading(false); // Stop loading state in case of error
    }finally{
        setLoading(false);
    }
  };
  

  return (
    <>
      <div className="bg-[#1d2951] flex justify-center items-center w-full h-[100vh]">
        <div className="bg-white rounded-3xl p-10 flex lg:flex-row md:flex-row sm:flex-row flex-col justify-between lg:w-[800px] sm:w-[90%] w-full shadow-lg">
          {/* Left Section */}
          <div className="lg:w-full sm:w-[70%] w-full">
            <div className="flex flex-col gap-3 p-2">
              {/* Logo and Text Section */}
              <div className="flex w-full justify-center">
                <div>
                  <img src={BrianyCareLogo} alt="C-HIM Logo" className="w-16 mb-4" />
                </div>
                <div className="flex flex-col ml-2 items-start">
                  <div
                    className="text-[32px] font-black text-[#1e90ff] leading-none"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    C-HIM
                  </div>
                  <div className="text-xs font-bold ml-1 mt-2">
                    Center for Hypertension & Internal Medicine
                  </div>
                </div>
              </div>
              <div className="font-semibold text-lg">{flow=='forgot'?"Forgot Your Password ?":"Reset Your Password ?"}</div>

              {/* Reset Password Section */}
              <div className="flex flex-col gap-3">
                <label htmlFor="email" className="text-sm text-left">
                  Email Address
                </label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  className="border border-gray-300 rounded-md p-2 text-sm w-full focus:outline-none focus:ring-0"
                />

                <button
                  onClick={handleSubmit}
                  className="bg-[#E17954] text-white px-3 py-2 text-sm rounded-3xl mt-4 focus:outline-none focus:ring-0"
                  disabled={loading} // Disable the button when loading
                >
                  {loading ? "Sending..." : "Reset Password"} {/* Change button text during loading */}
                </button>

                <button
                  onClick={() => navigate('/login', { replace: true })}
                  className="bg-[#E17954] text-white px-3 py-2 text-sm rounded-3xl mt-4 focus:outline-none focus:ring-0"
                >
                  Back to Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handlealert} />
    </>
  );
};

export default Forgotpassword;
